import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
import { api, formatApiError } from "../lib/api";

export default function ForgotPassword() {
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [sent, setSent] = useState(false);
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      await api.post("/auth/forgot-password", { email });
      setSent(true);
    } catch (err) {
      setError(formatApiError(err.response?.data?.detail) || err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="flex min-h-screen w-full items-center justify-center bg-cream px-6 py-12 sm:px-8">
      <motion.div initial={{ opacity: 0, y: 14 }} animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.55, ease: "easeOut" }} className="w-full max-w-[420px]">
        <div className="flex justify-center">
          <span className="logo-elevate text-6xl sm:text-7xl">elevate</span>
        </div>

        {sent ? (
          <div className="mt-12 text-center">
            <h1 className="font-sans text-2xl font-medium text-ink sm:text-3xl">Vérifie ta boîte mail 💌</h1>
            <p data-testid="forgot-sent" className="mt-3 font-sans text-sm font-light text-ink-soft">
              Si un compte existe avec cette adresse, tu recevras un lien pour choisir un nouveau mot de passe. Le lien est valable 1 heure.
            </p>
            <button data-testid="back-to-login" onClick={() => navigate("/login")}
              className="mt-8 rounded-full bg-bordeaux px-6 py-3 text-sm font-medium text-white transition hover:bg-bordeaux-dark">
              Retour à la connexion
            </button>
          </div>
        ) : (
          <>
            <div className="mt-12 text-center">
              <h1 className="font-sans text-3xl font-medium text-ink sm:text-4xl">Mot de passe oublié ?</h1>
              <p className="mt-3 font-sans text-sm font-light text-ink-soft sm:text-base">
                Indique ton adresse email, on t'envoie un lien pour le réinitialiser.
              </p>
            </div>
            <form onSubmit={submit} className="mt-10 space-y-5">
              <div>
                <label className="font-sans text-sm font-medium text-ink">Email</label>
                <input data-testid="forgot-email-input" type="email" value={email}
                  onChange={(e) => setEmail(e.target.value)} required
                  className="mt-2 w-full rounded-xl border border-line bg-white px-5 py-4 font-sans text-ink outline-none transition placeholder:text-ink-muted focus:border-bordeaux focus:ring-2 focus:ring-bordeaux/10"
                  placeholder="ton@email.com" />
              </div>
              {error && (
                <p data-testid="forgot-error" className="rounded-lg bg-bordeaux-tint px-4 py-3 font-sans text-sm font-light text-bordeaux">{error}</p>
              )}
              <button data-testid="forgot-submit-button" type="submit" disabled={loading}
                className="w-full rounded-full bg-bordeaux py-4 font-sans text-base font-medium text-white transition hover:bg-bordeaux-dark disabled:opacity-60">
                {loading ? "Envoi…" : "Recevoir le lien"}
              </button>
            </form>
            <p className="mt-10 text-center font-sans text-sm font-light text-ink-muted">
              <button data-testid="forgot-back-link" onClick={() => navigate("/login")}
                className="font-normal text-bordeaux underline decoration-bordeaux/30 underline-offset-4 transition hover:text-bordeaux-dark hover:decoration-bordeaux">
                Revenir à la connexion
              </button>
            </p>
          </>
        )}
      </motion.div>
    </div>
  );
}
